// api/guardianApi.ts
import { ScenarioNodeModel } from "../types/ScenarioDtos";
import { axiosClient } from "./axiosClient";

export const selectGuardianApi = async (guardian: string) => {
  return await axiosClient.get<ScenarioNodeModel>(`/scenarios/select/${guardian}`);
};

export const selectOptionApi = async (id: string) => {
  return await axiosClient.get<ScenarioNodeModel>(`/ScenarioNodes/select/${id}`);
};

export const getScenarioByGuardian = async (guardian: string)=>{
  return await axiosClient.get<Scenario>(`/Scenarios/getbyguardian/${guardian}`);
}